'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minutesAgo.js
// module id = 710
// module chunks = 0